/**
 * Converte texto de data em DD/MM/AAAA ou yyyy-MM-dd para yyyy-MM-dd.
 * @param {string} texto
 * @returns {string|null}
 */
export function textoDataParaIso(texto) {
  if (!texto) return null;
  const s = String(texto).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const parts = s.split("/");
  if (parts.length !== 3) return null;
  const [day, month, year] = parts;
  const d = day.padStart(2, "0");
  const m = month.padStart(2, "0");
  const y = year.padStart(4, "0");
  if (y.length !== 4) return null;
  return `${y}-${m}-${d}`;
}
